<h5 [ngStyle]="{'color': ( disabled ? 'var(--hover)' : 'var(--on-secondary)')}">{{ text | translate }}</h5>